import React, { useState } from 'react';
import PropTypes from 'prop-types';

import InfoBox from '../InfoBox';
import Disclaimer from '../Disclaimer';

import { useRules } from '../../lib/rules';
import { parseTags, normaliseKey } from '../../lib/string';

const Screen = ({ state, step, onNext }) => {
  const [info, setInfo] = useState(step.info || null);

  const { heading, subHeading = null, extraClass, autoSubmit = true, field } = step;
  const { name = heading, component: FieldComponent, rules, ...props } = field;

  const { title: disclaimerTitle = null, body: disclaimerBody = null } = step.disclaimer || {};

  if (state.hideScreen) {
    return <div />;
  }

  return (
    <div className={`quiz-section default-screen ${extraClass ? extraClass : ''}`}>
      <div className="quiz-section-inner text-center">
        <div className="form-label-wrapper">
          <h3 className="form-label">{parseTags(heading, state)}</h3>
          {!!subHeading && <p>{typeof subHeading === 'function' ? subHeading() : subHeading}</p>}
        </div>
        <FieldComponent
          defaultValue={state[normaliseKey(name)] || ''}
          rules={Array.isArray(rules) && useRules(rules, state)}
          name={name}
          autoSubmit={autoSubmit}
          onNext={onNext}
          onOptionChange={(option) => {
            const { info: description = null } = option;

            if (typeof description === 'string' || Array.isArray(description)) {
              setInfo({ title: null, description });
            } else {
              setInfo(description || step.info || null);
            }
          }}
          {...props}
        />
      </div>
      <div className={`quiz-section-bottom ${disclaimerTitle !== null ? 'has-learn-more' : ''}`}>
        {info !== null && <InfoBox title={info.title} info={info.description} />}
        {disclaimerTitle !== null && <Disclaimer title={disclaimerTitle} body={disclaimerBody} />}
        {info !== null && <div className="info-box-spacer" />}
      </div>
    </div>
  );
};

Screen.propTypes = {
  state: PropTypes.shape().isRequired,
  step: PropTypes.shape({
    heading: PropTypes.string.isRequired,
    subHeading: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    disclaimer: PropTypes.shape({
      title: PropTypes.string,
      body: PropTypes.oneOfType([PropTypes.elementType, PropTypes.shape()]),
    }),
    info: PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.string,
    }),
    autoSubmit: PropTypes.bool,
    field: PropTypes.shape({
      name: PropTypes.string,
      component: PropTypes.elementType.isRequired,
      rules: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.shape()])),
    }),
  }).isRequired,
  onNext: PropTypes.func.isRequired,
};

export default Screen;
